import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MdlModule } from '@angular-mdl/core';

import { TranslateModule } from '../translate/translate.module';
import { NotFoundRoutingModule } from './notFound-routing.module';
import { CopyrightFooterModule } from '../shared/components/copyright-footer/copyright-footer.module';

import { NotFoundComponent } from './notFound.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        MdlModule,
        NotFoundRoutingModule,
        TranslateModule,
        CopyrightFooterModule
    ],
    declarations: [
        NotFoundComponent
    ],
    providers: [

    ]
})

export class NotFoundModule { }
